import { useEffect } from "react";
import Header from "../components/organisms/common/Header";
import Footer from "../components/organisms/common/Footer";
import AppStorage from "../components/AppStorage";
import SEO from "../components/organisms/common/SEO";
import { removeLocalStorageItem } from "../util/utils";

const ErrorContent = ({ data }) => {
  return (
    <section className="container grid--default has-align-top hero--default pb-10">
      <article className="text-left">
        <h1
          className="text-lg lg:pt-5 lg:maxw-lg"
          dangerouslySetInnerHTML={{ __html: data.title }}
        ></h1>
        <p className="lg:maxw-mds lg:mb-2 md:mb-2">{data.desc}</p>
      </article>{" "}
      <figure className="layered-images-wrap pos-rel lg:maxw-lg md:mt-5">
        <picture>
          <img
            loading="lazy"
            src={data.backgroundImage.src}
            alt={data.backgroundImage.alt}
            className="bg-layer"
          />

          <img
            loading="lazy"
            src={data.foregroundImage.src}
            alt={data.foregroundImage.alt}
            className="fg-layer md:neg-left"
          />
        </picture>
      </figure>
    </section>
  );
};

export async function getStaticProps({ locale }) {
  let allData = {};
  let pageName = "invalid-referral-code";
  // Fetch data for respective pages
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );
  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );
  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/error/${pageName}/marketing.json`
  );
  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/error/${pageName}/content.json`
  );

  // Catch Error
  if (!marketingResponse.ok || !contentResponse.ok) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();
  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };
  const marketing = {
    marketing: allData.marketing,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...marketing,
    ...allData.content,
  };
  // Return to the component
  return {
    props: {
      data,
    },
  };
}
export default function Error({ data }) {
  useEffect(() => {
    removeLocalStorageItem("referralCode");
  }, []);
  return (
    <>
      <AppStorage pageName="Error Page" />
      <SEO data={data.marketing.seo} />
      <Header data={data.header} />
      <ErrorContent data={data.content.hero} />
      <Footer data={data.footer} />
    </>
  );
}
